<template>
    <div v-if="lang" class="detail-map-container">
        <!-- <div class="mapboxgl-poi">
            <template v-for="poi in options.modules.poi.all">
                <button type="button" :key="poi" :class="[poi, { 
                    'active': options.modules.poi.selected.includes(poi)
                }]" @click.stop="poiToggle(poi)"><div>{{ lang[poi] }}</div></button>
            </template>
        </div> -->
        <tecno-map
            ref="map"
            :options="options"
            class="detail-map"
        />
        <div id="detail-map-poi-controller" class="poiController"></div>
    </div>
</template>

<script>
import TecnoMap from './maps/Map'

export default {
    props: {
        marker: {
            type: [String,Boolean],
            required: false,
            default: false,
        },

        latitude: {
            type: Number,
            required: true,
        },

        longitude: {
            type: Number,
            required: true,
        },

        exact: {
            type: Boolean,
            required: false,
            default: true
        },

        poi: {
            type: Object,
            default () {
                return {
                    country: this.$root.country_full_name,
                    endpoint: window.tecnomapsEndpoint + '/v2/services/poi',
                    listener: false,
                    fixed: ['public_transport', 'school', 'pharmacy', 'ev_charging'],
                    element: 'detail-map-poi-controller'
                }
            }
        }
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail.points_of_interest
        },
    },

    data() {
        return {
            options: {
                minZoom: 14,
                maxZoom: 18,
                currentZoom: 16,
                style: '/core/v1/' + this.$root.country_full_name + '/style.json',

                currentBearing: -40,
                currentPitch: 60,

                mapCenter: {
                    coords: [ this.longitude, this.latitude ]
                },

                features: {
                    uriCoords: false,
                    scrollZoom: false,
                    dragRotate: true,
                    touchZoomRotate: false
                },

                modules: {
                    navigationControl: {
                        uiPosition: 'bottom-left',
                        zoom: true,
                        map3d: true
                    },
                    poi: this.poi
                    
                    // poi: {
                    //     endpoint: window.tecnomapsEndpoint + '/v2/services/poi',
                    //     listener: false,
                    //     all: ['public_transport', 'school', 'pharmacy', 'parking', 'ev_charging', 'shop', 'bank', 'fuel', 'market', 'hospital', 'monument', 'post', 'bar', 'restaurant', 'park'],
                    //     selected: ['public_transport', 'school', 'pharmacy'],
                    //     element: 'detail-map-poi-controller'
                    // }
                }
            }
        }
    },

    methods: {
        poiToggle(poi)
        {
            console.log('DetailMap - poiToggle', poi)
            window.dispatchEvent(new CustomEvent('tecnomap.poi.toggle', { detail: { 
                id: this.$refs.map.id, 
                poi: poi
            }}));
        },

        poiEnabled(event)
        {
            console.log('DetailMap - poiEnabled', event)
            // this.options.modules.poi.selected.push(event.detail.poi);
        },

        poiDisabled(event)
        {
            console.log('DetailMap - poiDisabled', event)
            // this.options.modules.poi.selected.remove(event.detail.poi);
        }
    },

    created() {
        // console.log('Portale/Maps/AgencyMap - created');

        if(this.exact)
        {
            this.options.mapCenter.marker = {
                color: this.$root.network == 'tecnorete' ? '#003596' : '#078c33'
            }
        }
        else
        {
            this.options.mapCenter.area = {
                color: this.$root.network == 'tecnorete' ? '#003596' : '#078c33',
            }
        }
    },

    mounted() {
        // console.log('Portale/Maps/AgencyMap - mounted');
        window.addEventListener('tecnomap.poi.enabled', this.poiEnabled);
        window.addEventListener('tecnomap.poi.disabled', this.poiDisabled);
    },

    beforeDestroy() {
        // console.log('Portale/Maps/AgencyMap - beforeDestroy');
        window.removeEventListener('tecnomap.poi.enabled', this.poiEnabled);
        window.removeEventListener('tecnomap.poi.disabled', this.poiDisabled);

    },

    components: {
        'tecno-map': TecnoMap
    }
}
</script>
